// Copyright (c) 2017 Deere & Company

import LaborAdditiveSummary from '@deere/cps-it.warranty-model-factory/lib/labor-additive-summary';
import actions from '../actions-list';
import {getDefaultState} from '../state';

const updateLaborAdditiveSummary = (state, action) =>
    LaborAdditiveSummary.update(state, {
        $set: action.laborAdditiveSummary
    });

export default (state = getDefaultState().laborAdditiveSummary, action) => {

    const actionTypes = {
        [actions.UPDATE_HOME_PAGE_LABOR_ADDITIVE_SUMMARY]: updateLaborAdditiveSummary
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/home-page/reducers/labor-additive-summary.js